module.exports = "<li class=\"floatL wid95\"><a class=\"<%= hasPrev ? 'forcia-page-review' : 'forcia-css-disabled' %> ipt_btnBK sml icon_arwWT_lft wid100p\" data-offset=-1>前へ</a></li> <li class=\"floatR wid95\"><a class=\"<%= hasNext ? 'forcia-page-review' : 'forcia-css-disabled' %> ipt_btnBK sml icon_arwWT_rgt wid100p\" data-offset=1>次へ</a></li> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/review-page.template.html
// module id = 70
// module chunks = 2